import React from "react"

import RightChevron from "../images/chevron-right.svg"
import ClinicianTeam from "./images/clinician-team.png"
import { Wrapper, ArrowWrapper } from "./styled"
import { useFeatureFlag } from "../../../hooks/useFeatureFlag"

const BecomeAProvider = () => {
  const isSiteUpdatesEnabled = useFeatureFlag(
    "growth_release_cerebral_rl_core_site_updates"
  )
  const careersUrl = isSiteUpdatesEnabled
    ? "/clinical-careers"
    : "https://get.cerebral.com/careers/"

  return (
    <Wrapper href={careersUrl}>
      <div>
        <img src={ClinicianTeam} alt="gift icon" />
        <p>Become a provider</p>
      </div>
      <ArrowWrapper>
        <img src={RightChevron} alt="right chevron arrow" />
      </ArrowWrapper>
    </Wrapper>
  )
}
export default BecomeAProvider
